import React from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import Team from '../Staff/OVCteam';
import Experts from '../Staff/OVCexperts';
import Collaborations from '../TextAssets/Collaborations';
import Exit from '../TextAssets/Exit';
import Expertise from '../TextAssets/Expertise';
import Mission from '../Home/index';
import Opportunities from '../TextAssets/Opportunities';
import SciencePark from '../TextAssets/SciencePark';
import Strategy from '../TextAssets/Strategy';
import SmartCity from '../TextAssets/SmartCity';
import AboutUs from '../Organization/index';
import Info from '../ContactCard/index';
import OVCstruct from '../CapitalStructure/index';
import './style.css';

class AppRouter extends React.Component {
  redirectToHome = () => {
    return (
      <Redirect to={{pathname: '/'}}/>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.location.pathname !== prevProps.location.pathname){
      if(this.props.location.pathname !== '/'){
        this.props.handler(false)
      }
      else {
        this.props.handler(true)
      }
    }

  }

  render() {
    return <div className="App__Body">
      <Switch>
        <Route exact path="/" component={Mission} />
        <Route path="/aboutus" component={AboutUs} />
        <Route path="/capitalstructure" component={OVCstruct} />
        <Route path="/team" component={Team} />
        <Route path="/experts" component={Experts} />
        <Route path="/collab" component={Collaborations} />
        <Route path="/exitstrategy" component={Exit} />
        <Route path="/expertise" component={Expertise} />
        <Route path="/mission" component={Mission} />
        <Route path="/opportunities" component={Opportunities} />
        <Route path="/science" component={SciencePark} />
        <Route path="/strategy" component={Strategy} />
        <Route path="/smartcity" component={SmartCity} />
        <Route path="/contactus" component={Info} />
        <Route path='*' component={this.redirectToHome} />
    </Switch>
    </div>;
  }
}

export default withRouter(AppRouter);


// <Route path="/legal" component={LegalHK} />
// <Route path="/board" component={Board} />
